import { Component, Input, inject } from '@angular/core';
import {FirebaseService} from '../../../core/services/firebase.service';
import {CateringMenu} from '../../../models/menu-item.model';

interface CateringMenuItem extends CateringMenu {
    id: string;
    isEditButtonClicked: boolean;
}
import {Subscription} from 'rxjs';
import { NgClass } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatCard, MatCardHeader, MatCardTitle, MatCardContent } from '@angular/material/card';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-catering-menu-template',
    templateUrl: './catering-menu-template.component.html',
    styleUrls: ['./catering-menu-template.component.scss'],
    imports: [MatButton, MatCard, MatCardHeader, MatCardTitle, MatCardContent, FormsModule, NgClass]
})
export class CateringMenuTemplateComponent {
    firebaseService = inject(FirebaseService);

    @Input() isDeleteVisible: boolean | null | undefined;
    cateringMenuItems: CateringMenuItem[] = [];
    isAddCateringDialogVisible = false;
    cateringMenu: CateringMenu = new CateringMenu();
    cateringMenuError: Record<string, unknown> = {};
    subscriptions: Subscription = new Subscription();

    constructor() {
        this.getCateringMenuItems();
    }

    getCateringMenuItems() {
        this.subscriptions.add(
            this.firebaseService.getCateringMenuItems().subscribe(data => {
                this.cateringMenuItems = [];
                this.cateringMenuItems = data?.map(x => ({id: x.id, data: x.data()}))
                    .map((value) =>
                        ({
                            isEditButtonClicked: false,
                            isVisible: value.data.isVisible,
                            price: value.data.price,
                            qty: value.data.qty,
                            items: value.data.items,
                            title: value.data.title,
                            id: value.id,
                            description: value.data.description,
                            showDescription: value.data.showDescription
                        })
                    );
            }));
    }

    cancelCateringMenu() {
        this.cateringMenu = new CateringMenu();
        this.cateringMenuError = {};
        this.isAddCateringDialogVisible = false;
    }

    onValueChange(e: Event, index: number) {
        this.cateringMenu.items[index] = (e.target as HTMLInputElement).value;
    }

    removeCateringMenuItem(index: number) {
        this.cateringMenu.items.splice(index, 1);
    }

    addCateringMenuItem() {
        this.cateringMenu.items.push('');
    }

    deleteCateringMenu(item: CateringMenuItem) {
        this.firebaseService.deleteCateringMenuItem(item.id).then(
            res => {
                console.warn(res);
            }
        );
    }

    updateCateringMenu(item: CateringMenuItem) {
        this.firebaseService.updateCateringMenu(item.id, item).then(
            res => {
                console.warn(res);
                item.isEditButtonClicked = false;
                this.isAddCateringDialogVisible = false;
            }
        );
    }

    addCateringMenu() {
        this.cateringMenuError.touched = true;
        if (this.isValidCatering()) {
            this.cateringMenu.showDescription = !this.cateringMenu.description ? false : this.cateringMenu.showDescription;
            this.firebaseService.addCateringMenu(this.cateringMenu).then(
                () => {
                    this.cateringMenu = new CateringMenu();
                }
            );
        }
    }

    isValidCatering() {
        this.cateringMenuError.items = !this.cateringMenu.items.length;
        this.cateringMenuError.title = !this.cateringMenu.title;
        this.cateringMenuError.qty = !this.cateringMenu.qty;
        this.cateringMenuError.price = !this.cateringMenu.price;

        this.cateringMenuError.isInvalid = this.cateringMenuError.items || this.cateringMenuError.title
            || this.cateringMenuError.qty || this.cateringMenuError.price;

        return !this.cateringMenuError.isInvalid;
    }

    addNewCateringMenuClicked() {
        this.isAddCateringDialogVisible = true;
    }

    hasAnyEditButtonClicked() {
        return this.cateringMenuItems.some(item => item.isEditButtonClicked);
    }

    editButtonClicked(item: CateringMenuItem) {
        item.isEditButtonClicked = true;
        this.cateringMenu = item;
        this.isAddCateringDialogVisible = true;
    }

    cancelUpdate(item: CateringMenuItem) {
        item.isEditButtonClicked = false;
        this.cateringMenu = new CateringMenu();
        this.isAddCateringDialogVisible = false;
    }

    updateCateringMenuItem(m: CateringMenuItem) {
        this.firebaseService.updateCateringMenu(m.id, m).then(res => {
            console.warn(res);
        });
    }

    getItemType(item: string) {
        return item.split(':')[0];
    }

    getItemDescription(item: string) {
        return item.split(':')[1];
    }
}

